// extracted by mini-css-extract-plugin
export default {"RowError":"RowError_RowError__Zoj4W","RowError__Text":"RowError_RowError__Text__xHFoT","RowError__Icon":"RowError_RowError__Icon__wBKWL"};